
import { api } from './api';

export const groupsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getGroups: build.query({
      query: () => ({
        url: "groups",
        method: "GET",
      }) ,
      providesTags: (result) => [{ type: 'Groups', id: 'LIST' }]
    }),
  }),
});


export const {
  useGetGroupsQuery,
  useLazyGetGroupsQuery,
} = groupsApi;
